import React, { useEffect } from 'react';
import './Comment.css';
import { useTranslation } from 'react-i18next';
import Star from '../ui/Stars';

const Comment = ({ stars, time, description, username }) => {
  const { i18n } = useTranslation();

  useEffect(() => {
    i18n.changeLanguage(localStorage.getItem('lang'));
  }, [i18n]);

  return (
    <>
      <div id="userReview" className="card mx-3 mb-4 rounded-plus">
        <div className="d-flex w-100 bg-white p-3 justify-content-between">
          <div id="userReviewStars">
            <Star rating={stars} />
            <span id="userReviewRanking"> {stars}/5 </span>
          </div>
          <small id="userReviewDate" className="text-muted">
            {time}
          </small>
        </div>
        <div className="card-body">
          <p id="userReviewComment" className="card-text work-sans-pwa">
            {description}
          </p>
          <p className="font-weight-bold roboto-pwa">
            Por: <span id="userReviewUserName"> {username} </span>
          </p>
        </div>
      </div>
    </>
  );
};

export default Comment;
